import * as React from "react";
const Wrapper = ({ children }: { children: React.ReactNode }) => <div>{children}</div>;
export default Wrapper;
